var _regeneratorRuntime = require("/codebuild/output/src376375596/src/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/codebuild/output/src376375596/src/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/codebuild/output/src376375596/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

require("core-js/modules/es.promise.finally.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _require = require("../../utility"),
    getUserId = _require.getUserId,
    getPageTypeFromURL = _require.getPageTypeFromURL,
    getClickToCallDepartment = _require.getClickToCallDepartment;
/**
 * Build page view data to be processed.
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {object} Data or failure message of data processing.
 */


function buildPageViewData(data) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resolve(_objectSpread(_objectSpread({}, data), {}, {
                page_type: getPageTypeFromURL()
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
/**
 * Default handler for ASC events.
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */


function ASC_Handler(data, options) {
  try {
    // Builders for specific events
    // switch (data.event) {
    //     case 'asc_pageview':
    //         data = await buildPageViewData(data)
    //         break;
    // }
    // Default Data
    data = _objectSpread(_objectSpread({}, data), {}, {
      // ...(options.shouldIncludeEventOwner === false ? {} : { event_owner: getUserId() } ),
      ignore_for_GTM: false,
      event_owner: "Dealer Masters",
      page_type: page_type = data.page_type ? data.page_type : function (element) {
        return element ? element.value : getPageTypeFromURL();
      }(document.querySelector('data[id="page"]')),
      timestamp: new Date().toISOString()
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    return {
      status: 'success',
      message: "ASC event ".concat(data.event, " processed successfully"),
      data: data
    };
  } catch (error) {
    return {
      status: 'error',
      message: "ASC Handler failed to capture event. Error: ".concat(err.message),
      data: data
    };
  }
}
/**
 * Adds event handlers to navigation items for ASC capture event processing.
 * @returns {string} Success or failure message of data processing.
 */


function AddASCNavHandlers() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var anchors;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                if (typeof document !== 'undefined') {
                  anchors = document.querySelectorAll("#nav_link");
                  anchors.forEach(function (anchor) {
                    anchor.addEventListener('click', function (event) {
                      event.preventDefault();
                      var href = event.currentTarget.getAttribute('href');
                      if (!href) return;
                      captureEvent({
                        'event': 'asc_menu_interaction',
                        'page_type': getPageTypeFromURL(),
                        'element_text': "".concat(event.currentTarget.innerText),
                        'element_subtype': 'nav_button',
                        'element_type': 'main',
                        'event_action': 'click'
                      }, {
                        handlers: ['ASC'] // shouldIncludeEventOwner: props.shouldIncludeEventOwner

                      }).then(function (response) {
                        console.log(response);
                      }).catch(function (error) {
                        console.log(error);
                      }).finally(function () {
                        if (event.currentTarget.hostname != window.location.hostname) {
                          window.open(href, '_blank');
                        } else if (href) {
                          if (window.navigate) return window.navigate(href);
                          if (window.gatsbyNavigate) return window.gatsbyNavigate(href);
                          console.log('No navigation function found.');
                        }
                      });
                    });
                  });
                  resolve('ASC navigation handlers added successfully.');
                } else {
                  reject('Cannot add navigation handlers, Document is not defined.');
                }
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
}
/**
 * Adds event handlers to clickable elements for ASC capture event processing.
 * @returns {string} Success or failure message of data processing.
 */


function AddASCClickableHandlers() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Adds button elements with onClick event\
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
      var pageElement, pageValue, buttons;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!(typeof document !== 'undefined')) {
                _context3.next = 11;
                break;
              }

              pageElement = document.querySelector('data[id="page"]');
              pageValue = pageElement ? pageElement.value : null; // Check if page is SRP or VDP

              if (!(pageValue === 'Vehicle Display Page' || pageValue === 'Search Results Page')) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", reject('SRP/VDP page detected, skipping ASC clickable elements handlers.'));

            case 6:
              // Query all clickable elements that are not already handled by other handlers
              buttons = document.querySelectorAll('button[onclick], a:not([id="nav_link"]):not([href*=tel])[href], img[onclick]'); // Add event handlers to clickable elements

              buttons.forEach(function (anchor) {
                anchor.addEventListener('click', function (event) {
                  var _captureEvent;

                  event.preventDefault();
                  var href = event.currentTarget.getAttribute('href');
                  captureEvent((_captureEvent = {
                    event: 'asc_cta_interaction'
                  }, _defineProperty(_captureEvent, "event", 'asc_cta_interaction'), _defineProperty(_captureEvent, "page_type", getPageTypeFromURL()), _defineProperty(_captureEvent, "element_text", "".concat(event.currentTarget.innerText)), _defineProperty(_captureEvent, "element_color", "".concat(window.getComputedStyle(event.currentTarget).color)), _defineProperty(_captureEvent, "element_type", 'button'), _defineProperty(_captureEvent, "event_action", 'click'), _defineProperty(_captureEvent, "event_action_result", "".concat(href ? 'open' : 'Other')), _defineProperty(_captureEvent, "link_url", "".concat(href || '')), _captureEvent), {
                    handlers: ['ASC'] // shouldIncludeEventOwner: props.shouldIncludeEventOwner

                  }).then(function (response) {
                    console.log(response);
                  }).catch(function (error) {
                    console.log(error);
                  }).finally(function () {
                    if (href) {
                      if (event.currentTarget.hostname != window.location.hostname) {
                        window.open(href, '_blank');
                      } else {
                        if (window.navigate) return window.navigate(href);
                        if (window.gatsbyNavigate) return window.gatsbyNavigate(href);
                        console.log('No navigation function found.');
                      }
                    }
                  });
                });
              });
              resolve('ASC clickable elements handlers added successfully.');
              _context3.next = 12;
              break;

            case 11:
              reject('Cannot add clickable element handlers, Document is not defined.');

            case 12:
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              reject(_context3.t0);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
}
/** 
 * Adds event handlers to anchors with tel href for ASC capture event processing.
 * @returns {string} Success or failure message of data processing.
*/


function AddASCClickToCallHandlers() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
      var anchors;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              try {
                if (typeof document !== 'undefined') {
                  anchors = document.querySelectorAll('a[href^="tel:"]');
                  anchors.forEach(function (anchor) {
                    anchor.addEventListener('click', function (event) {
                      event.preventDefault();
                      var element = event.currentTarget;
                      var href = element.getAttribute('href');
                      var number = href.replace('tel:', '').replace(/-/g, '').replace(/\s/g, '');
                      var department = getClickToCallDepartment(element, number) || 'sales';
                      captureEvent({
                        event: 'asc_click_to_call',
                        comm_phone_number: number,
                        department: department
                      }, {
                        handlers: ['ASC'] // shouldIncludeEventOwner: props.shouldIncludeEventOwner

                      }).then(function (response) {
                        console.log(response);
                      }).catch(function (error) {
                        console.log(error);
                      }).finally(function () {
                        window.location.href = href;
                      });
                    });
                  });
                  resolve('ASC click to call handlers added successfully.');
                } else {
                  reject('Cannot add click to call handlers, Document is not defined.');
                }
              } catch (err) {
                reject(err);
              }

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }());
}

module.exports = {
  ASC_Handler: ASC_Handler,
  AddASCNavHandlers: AddASCNavHandlers,
  AddASCClickableHandlers: AddASCClickableHandlers,
  AddASCClickToCallHandlers: AddASCClickToCallHandlers
};